<template>
  <div id="page" class="v-application v-application--is-ltr">
    <div class="app-content" :class="{show: show}">
      <div class="order-btn" @click="$router.push({path: '/orders'})"><img src="@/assets/images/btn1.png" alt=""></div>
      <div class="banner" v-if="false">
        <div class="swiper-banner swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="@/assets/images/bann1.png" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@/assets/images/bann1.png" alt="">
            </div>
          </div>
          <div class="swiper-pagination swiper-pagination1"></div>
        </div>
      </div>
      <div class="ticket-category-wrap top-ticket">
        <div class="swiper-items swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(v, k) in topProducts" :key="k">
              <ul class="items">
                <li v-for="item in v" :key="item.id" @click="() => onDetail(item)">
                  <span class="icon" v-if="item.thumb"><img :src="item.thumb" alt=""></span>
                  <span class="icon" v-else><img src="@/assets/images/item1.png" alt=""></span>
                  <span class="name">{{item.name}}</span>
                  <span class="desc">{{item.describe}}</span>
                  <span class="badge" v-if="item.badge">{{item.badge}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="swiper-pagination swiper-pagination2"></div>
        </div>
      </div>
      <div class="ticket-category-list">
        <div class="category-wrap">
          <ul>
            <li :class="{cur: categoryId === 0}" @click="categoryId = 0; onScroll(0)"><span>热门推荐</span></li>
            <li :class="{cur: categoryId === cate.id}" v-for="(cate, k) in category" :key="cate.id" @click="categoryId = cate.id;onScroll(k+1)"><span>{{cate.name}}</span></li>
          </ul>
        </div>
        <div class="flex">
          <div class="ticket-category-wrap" ref="hot_group">
            <div class="cate-title"><span>热门推荐</span></div>
            <ul class="items">
              <li v-for="item in products" :key="item.id" v-if="item.is_hot" @click="() => onDetail(item)">
                <span class="icon" v-if="item.thumb"><img :src="item.thumb" alt=""></span>
                <span class="icon" v-else><img src="@/assets/images/item1.png" alt=""></span>
                <span class="name">{{item.name}}</span>
                <span class="desc">{{item.describe}}</span>
                <span class="badge" v-if="item.badge">{{item.badge}}</span>
              </li>
            </ul>
          </div>
          <div class="ticket-category-wrap" ref="group" v-for="cate in category" :key="cate.id">
            <div class="cate-title"><span>{{cate.name}}</span></div>
            <ul class="items">
              <li v-for="item in products" :key="item.id" v-if="item.cid === cate.id" @click="() => onDetail(item)">
                <span class="icon" v-if="item.thumb"><img :src="item.thumb" alt=""></span>
                <span class="icon" v-else><img src="@/assets/images/item1.png" alt=""></span>
                <span class="name">{{item.name}}</span>
                <span class="desc">{{item.describe}}</span>
                <span class="badge" v-if="item.badge">{{item.badge}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div v-if="showToast">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast weui-toast_text">
          <p class="weui-toast__content">{{ toastMsg }}</p>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showLoading">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <span class="weui-primary-loading weui-icon_toast">
            <span class="weui-primary-loading__dot"></span>
          </span>
          <p class="weui-toast__content">加载中...</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="less" scoped>
@import "../mixins";

#page {
  min-height: 100vh;
  background-color: #fff;
}

.app-content {
  opacity: 0;
  transition: opacity 0.2s ease;
  background-color: #f8f8f8;
}

.app-content.show {
  opacity: 1;
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.2s;
}

.banner {
  padding: 0.2rem;
}
.top-ticket {
  padding-top: 0.2rem !important;
}
.top-ticket .items {
  height: 4.65rem;
}

.order-btn {
  display: block;
  width: 1.87rem;
  height: .75rem;
  position: fixed;
  top: .35rem;
  right: 0;
  z-index: 101;
}

.swiper-banner > .swiper-pagination {
  bottom: 5px;
  /deep/ .swiper-pagination-bullet {
    width: 10px;
    height: 3px;
    border-radius: 3px;
    margin: 0 3px;
    opacity: 1;
    background-color: rgba(255, 255, 255, 0.4);
    &.swiper-pagination-bullet-active {
      background-color: #fff;
    }
  }
}

.swiper-items {
  height: 4.9rem;
  box-sizing: content-box;
  padding-bottom: 0.2rem;
  .swiper-pagination {
    bottom: 0.2rem;
  }
  /deep/ .swiper-pagination-bullet {
    width: 10px;
    height: 3px;
    border-radius: 3px;
    margin: 0 3px;
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.2);
    &.swiper-pagination-bullet-active {
      background-color: #ddb47e;
    }
  }
}

.ticket-category-wrap {
  padding: 0 0.2rem;
  .cate-title {
    position: relative;
    height: 0.76rem;
    line-height: 0.76rem;
    font-size: 16px;
    font-weight: bold;
    padding-left: 0.46rem;
    color: #000;
    &:before {
      position: absolute;
      top: 50%;
      left: .2rem;
      width: 4px;
      height: 16px;
      margin-top: -8px;
      border-radius: 4px;
      background-color: #ddb47e;
      content: '';
    }
  }
  .items {
    padding-top: 5px;
    padding-left: 0.08rem;
    min-height: 1.2rem;
    overflow: hidden;
    li {
      float: left;
      position: relative;
      margin-right: 0.2rem;
      width: 22.5%;
      height: 2.12rem;
      margin-bottom: 0.2rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      border-radius: 6px;
      overflow: hidden;
      &:nth-child(4n+0) {
        margin-right: 0;
      }
      .icon {
        width: 0.92rem;
        height: 0.92rem;
        margin-top: 0.1rem;
        margin-bottom: 0.1rem;
      }
      .name, .desc {
        height: 0.36rem;
        line-height: 0.36rem;
        white-space: nowrap;
      }
      .name {
        font-size: 0.26rem;
        color: #333;
        font-weight: 500;
      }
      .desc {
        font-size: 0.24rem;
        color: #9d9d9d;
      }
      .badge {
        position: absolute;
        top: 0.135rem;
        right: 0.1rem;
        background-color: #eb6323;
        border-radius: 0.36rem;
        color: #fff;
        font-size: 0.24rem;
        padding: 0.075rem 0.175rem;
        transform: scale(0.8);
        min-width: 0.6rem;
        text-align: center;
        &:after {
          position: absolute;
          left: 50%;
          bottom: -6px;
          width: 0;
          height: 0;
          border-top: 6px solid transparent;
          border-right: 12px solid #eb6323;
          border-bottom: 6px solid transparent;
          content: '';
          transform: rotate(-64deg);
        }
      }
    }

  }
}

.ticket-category-list {
  display: flex;
  flex-direction: row;
  .category-wrap {
    position: relative;
    width: 1.64rem;
    &:before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #fff;
      border-radius: 0 10px 10px 0;
      content: '';
    }
    ul {
      position: sticky;
      top: 0;
      left: 0;
      padding: 0.2rem 0;
      li {
        position: relative;
        text-align: center;
        height: 0.8rem;
        line-height: 0.8rem;
        font-weight: 500;
        span {
          display: block;
          font-size: 0.28rem;
          color: #9d9d9d;
        }
        &.cur {
          &:before {
            position: absolute;
            left: 0;
            top: 50%;
            width: 4px;
            height: 20px;
            margin-top: -10px;
            background-color: #ddb47e;
            border-radius: 0 4px 4px 0;
            content: '';
          }
          span {
            color: #ddb47e;
          }
        }
      }
    }
  }
  .flex {
    flex: 1;
    margin: 0 0.24rem;
  }
  .ticket-category-wrap {
    padding: 0.2rem 0 0;
    background-color: #fff;
    border-radius: 10px;
    margin-bottom: 0.24rem;
    .cate-title {
      padding-left: 0.24rem;
      &:before {
        display: none;
      }
    }
    .items {
      li {
        width: 30%;
        &:nth-child(4n+0) {
          margin-right: 0.2rem;
        }
        &:nth-child(3n+0) {
          margin-right: 0;
        }
      }
    }
  }
}

</style>

<script>
import request from "../utils/request";
import moment from 'moment';
import {chunk, throttle} from "lodash"

export default {

  data() {
    return {
      show: false,
      showLoading: true,
      showToast: false,
      checkAppKey: false,
      isWxPay: false,
      isAliPay: false,
      memberId: null,
      products: [],
      topProducts: [],
      category: [],
      categoryId: 0,
      goodsId: null,
      stickyDoms: [],
      pageReminder: '',
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.global.userInfo
    },
    appEnv() {
      return this.$store.state.global.appEnv
    },
  },
  created() {
    if (!this.appEnv.prod) {
      const appEnv = {
        prod: this.appEnv.prod,
        appId: 'CC202104110012172897',
        appKey: 'EDF0763043A073BC',
        platformId: 392,
      }
      const userInfo = {
        id: 10653,
        mobile: '18958906820',
        invite_code: "10311",
        avatar: "http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLD9jWrnw4j9YFHIKiaE71Pka0Bnz2t8vjcQGax1YibKPLehSjhfqd0uibFziaC1unYb5O80OUI7VDGsQ/132",
        nickname: "文贤",
      };
      this.$store.dispatch('global/commitAppEnv', appEnv)
      this.$store.dispatch('global/commitUserInfo', userInfo)
      new VConsole();
    }
  },
  mounted() {
    const prod = this.appEnv.prod;
    const appEnv = prod ? Object.assign({}, this.appEnv, {appKey: ''}) : this.appEnv;
    const appId = this.$route.query.appid ||'';
    const platformId = this.$route.query.platformid || '';
    this.goodsId = this.$route.query.goodsid || null;
    if (appId) appEnv.appId = appId;
    if (platformId) appEnv.platformId = parseInt(platformId, 10) || 0;
    if (!appEnv.appId || !appEnv.platformId) {
      this.show = true;
      this.showLoading = false;
      this.toast('商家存在未配置的参数请联系客服');
      return;
    }
    this.$store.dispatch('global/commitAppEnv', appEnv);
    const mounted = () => {
      const h5Userinfo = getH5UserInfo();
      if (h5Userinfo) {
        new Promise(async () => {
          await h5Userinfo.then((resp) => {
            const userInfo = JSON.parse(resp);
            console.log('userinfo', userInfo, resp);
            userInfo.latitude = this.userInfo.latitude;
            userInfo.longitude = this.userInfo.longitude;
            this.isWxBind = !!+userInfo.wx_bind;
            this.$store.dispatch('global/commitUserInfo', userInfo)
          }).catch((err) => {
            if (typeof err === 'object') {
              this.toast('未能获取到用户信息请联系客服: ' + JSON.parse(err));
            } else if (typeof err === 'string') {
              this.toast('未能获取到用户信息请联系客服: ' + err);
            }
          });
          let appKey = '';
          await checkAppInfo().then(version => {
            appKey = version;
          }).catch((err) => {});
          await this.getTenantCfg(appKey).catch((err) => {});
          await this.appMemberLink().then(() => {
            if (this.goodsId) {
              this.$router.replace({
                path: '/detail',
                query: {id: +this.goodsId},
              })
            }
          }).catch(err => {});
          await Promise.all([this.getCategory(), this.getProducts()]).then(() => {
            this.$nextTick(() => {
              this.initSwiper();
            })
            this.stickyDoms.push(this.$refs.hot_group)
            for (const dom of this.$refs.group) {
              this.stickyDoms.push(dom);
            }
            if (!this.goodsId) {
              this.show = true;
              this.showLoading = false;
            }
          }).catch(err => {})
        })
      } else {
        if (!this.appEnv.prod) {
          new Promise(async () => {
            await this.getTenantCfg(this.appEnv.appKey).catch((err) => {});
            await this.appMemberLink().then(() => {
              if (this.goodsId) {
                this.$router.replace({
                  path: '/detail',
                  query: {id: +this.goodsId},
                })
              }
            }).catch(err => {});
            await Promise.all([this.getCategory(), this.getProducts()]).then(() => {
              this.$nextTick(() => {
                this.initSwiper();
              })
              this.stickyDoms.push(this.$refs.hot_group)
              for (const dom of this.$refs.group) {
                this.stickyDoms.push(dom);
              }
              if (!this.goodsId) {
                this.show = true;
                this.showLoading = false;
              }
            }).catch(err => {})
          })
        } else {
          this.show = true;
          this.showLoading = false;
          this.toast('未能获取到用户信息请联系客服');
        }
      }
    }
    mounted();
    // window.addEventListener('scroll', throttle(this.handleScroll, 100)) // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
  },
  methods: {
    moment,
    handleScroll(){
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
    },
    onScroll(key) {
      const dom = this.stickyDoms[key];
      dom.scrollIntoView({ block: 'start', behavior: 'smooth' })
    },
    initSwiper() {
      // new Swiper(".swiper-banner", {
      //   pagination: '.swiper-pagination1',
      //   paginationClickable: true,
      //   autoplay:4000,
      //   spaceBetween: 30,
      //   speed: 400,
      //   effect: 'slide',
      //   loop:true
      // });
      new Swiper(".swiper-items", {
        pagination: '.swiper-pagination2',
        paginationClickable: true,
        spaceBetween: 30,
        speed: 400,
        effect: 'slide',
        // loop:true
      });
    },
    onDetail(record) {
      if (record.type === 'ticket' || record.type === 'recharge') {
        this.$router.push({
          path: '/detail',
          query: {id: record.id},
        })
      } else {
        window.location.href = record.custom_url
      }
    },
    getCategory() {
      const newRequest = request({
        url: `/open/api/product/category`,
        method: 'GET',
      });
      newRequest.then((resp) => {
        this.category = (resp || []).map(t => {
          t.list = [];
          return t;
        });
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      });
      return newRequest;
    },
    getProducts() {
      const newRequest = request({
        url: `/open/api/product/specs`,
        method: 'GET',
        params: {appid: this.appEnv.appId, platformId: this.appEnv.platformId, appkey: this.appEnv.appKey}
      });
      newRequest.then((resp) => {
        this.products = (resp || []).filter(t => {
          if (t.type === 'ticket' || t.type === 'recharge') {
            return t.specs && t.specs.length
          } else {
            return true;
          }
        }).map(t => {
          if (!t.describe && t.type === 'ticket' || t.type === 'recharge') {
            const {price, official_price} = t.specs[0];
            t.describe = (price / official_price * 10).toFixed(1) + '折起';
          }
          return t;
        }).sort((a, b) => b.sort - a.sort);
        this.topProducts = chunk(this.products.filter(t => t.is_top), 8);
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      });
      return newRequest;
    },
    getTenantCfg(version) {
      const newRequest = request({
        url: `/open/api/account/config`,
        method: 'GET',
        params: {appid: this.appEnv.appId, platformId: this.appEnv.platformId, appkey: version}
      });
      newRequest.then((resp) => {
        const {expiry_at, appkey, wxpay, alipay, page_reminder } = resp;
        const appEnv = this.appEnv
        appEnv.appKey = version;
        this.isWxPay = wxpay;
        this.isAliPay = alipay;
        this.checkAppKey = appkey === version;
        this.pageReminder = page_reminder.split(/[\n\r]/g);
        const expiryAt = moment(expiry_at, 'YYYY-MM-DD HH:mm');
        const nowAt = moment(new Date());
        if (nowAt.isAfter(expiryAt)) {
          this.isExpiryAtOut = true;
          this.toast('服务存在异常，错误码：10001');
        }
        this.$store.dispatch('global/commitAppEnv', appEnv);
        this.$store.dispatch('global/commitWxPay', wxpay);
        this.$store.dispatch('global/commitAliPay', alipay);
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      });
      return newRequest;
    },
    appMemberLink() {
      const newRequest = request({
        url: `/open/api/member/link`,
        method: 'POST',
        data: {
          appid: this.appEnv.appId,
          platformId: this.appEnv.platformId,
          appkey: this.appEnv.appKey,
          uid: this.userInfo.id,
          nickname: this.userInfo.nickname,
          avatar: this.userInfo.avatar,
          invite_code: this.userInfo.invite_code
        }
      });
      newRequest.then((resp) => {
        this.memberId = resp.id;
      }).catch((error) => {
        if (error.response && error.response.data) {
          this.toast(error.response.data.msg);
        }
      })
      return newRequest;
    },
    onIssue() {
      if (this.appEnv.appKey === '44D36A9F643D169F') {
        window.location.href = 'https://www.taowuyou.com/kefu/weixin/';
      } else if (this.appEnv.appKey === '849B8FB49463D4D9') {
        window.location.href = 'https://work.weixin.qq.com/kfid/kfc9ad9e86ab24762ad';
      } else {
        openLinkByAlias('customerService');
      }
    },
    isHuaJuanY() {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.indexOf('huajuanyun') !== -1 || ua.indexOf('html5plus') !== -1 || this.userInfo.id;
    },
    toast(v, write = true) {
      this.toastMsg = v;
      if (this.isHuaJuanY()) {
        showToast(v);
      } else {
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 2000)
      }
      if (write) {
        request({
          url: `/open/api/analysis/log`,
          method: 'POST',
          data: {
            uid: this.userInfo.id,
            appid: this.appEnv.appId,
            appkey: this.appEnv.appKey,
            platformId: this.appEnv.platformId,
            nickname: this.userInfo.nickname,
            msg: v
          },
        }).then().catch(err => {
        })
      }
    },
  }
}
</script>
